/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MoveFolderContentsResponseCto } from '../../models/move-folder-contents-response-cto';

export interface MoveFolderContents_1$Json$Params {
  CompanyId: number;
  SourceFolderId: number;
  DestinationFolderId: number;
}

export function moveFolderContents_1$Json(http: HttpClient, rootUrl: string, params: MoveFolderContents_1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MoveFolderContentsResponseCto>> {
  const rb = new RequestBuilder(rootUrl, moveFolderContents_1$Json.PATH, 'patch');
  if (params) {
    rb.query('CompanyId', params.CompanyId, {});
    rb.query('SourceFolderId', params.SourceFolderId, {});
    rb.query('DestinationFolderId', params.DestinationFolderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MoveFolderContentsResponseCto>;
    })
  );
}

moveFolderContents_1$Json.PATH = '/folder/movefoldercontents';
